import type {SuppliedFilterProvider} from '@github-ui/filter-core'
import {NestedFilterProvider} from '@github-ui/filter-core/providers'

import type {PickerScope} from '../types'

export function adjustProvidersToScope(
  providers: SuppliedFilterProvider[],
  scope: PickerScope,
): SuppliedFilterProvider[] {
  disableHasAndNoFilters(providers)

  if (scope.visibility) {
    return updateVisibilityProvider(providers, scope.visibility)
  }

  return providers
}

function disableHasAndNoFilters(providers: SuppliedFilterProvider[]) {
  for (const provider of providers) {
    if (provider instanceof NestedFilterProvider) {
      for (const subProvider of provider.filterProviders) {
        subProvider.options.filterTypes.valueless = false
        subProvider.options.filterTypes.hasValue = false
      }
    } else {
      provider.options.filterTypes.valueless = false
      provider.options.filterTypes.hasValue = false
    }
  }
}

function updateVisibilityProvider(providers: SuppliedFilterProvider[], visibility: string[]): SuppliedFilterProvider[] {
  const isSingleVisibilityValue = visibility.length === 1

  return providers.filter(provider => {
    if (provider instanceof NestedFilterProvider || provider.key !== 'visibility') {
      return true
    }

    if (isSingleVisibilityValue) return false

    provider.filterValues = (provider.filterValues || []).filter(
      ({value}) => typeof value === 'string' && visibility.includes(value),
    )

    return true
  })
}
